import http from 'plugins/axios';

export default {
  getCodeList({page,size,zh}) {
    return http.post({
      url: `/la/admin/countryCode/list?page=${page}&size=${size}`,
      data:{
        zh
      }
      // dataType: 'form'
    });
  },

  delOneCountryCode(id) {
    return http.post({
      url: '/la/admin/countryCode/del/' + id,
    });
  },
  addOneCountry(data) {
    return http.post({
      url: '/la/admin/countryCode/add',
      data,
    });
  },
  updateCode(data) {
    return http.post({
      url: '/la/admin/countryCode/update',
      data,
    });
  },
};
